/**
 * Referencias a los tokens de color de los temas (src/themes/*.css) para
 * usar en `sx`/`style`: sx={{ color: T.text, borderColor: T.border }}.
 * No escribas colores a mano en componentes: si falta un token, agrégalo a
 * TODAS las hojas de src/themes/ (el test de temas lo exige).
 */
const v = (name) => `var(--wb-${name})`;

export const T = {
  bgPage: v('bg-page'), bgPanel: v('bg-panel'), bgSurface: v('bg-surface'), bgSurfaceAlt: v('bg-surface-alt'),
  bgCard: v('bg-card'), bgElevated: v('bg-elevated'), bgDeep: v('bg-deep'), bgHeader: v('bg-header'), surfaceWhite: v('surface-white'),
  bgOverlay90: v('bg-overlay-90'), bgOverlay70: v('bg-overlay-70'), bgOverlay60: v('bg-overlay-60'),
  textTitle: v('text-title'), text: v('text'), textLabel: v('text-label'), textStrong: v('text-strong'),
  textSoft: v('text-soft'), textFaint: v('text-faint'), textDim: v('text-dim'), textGhost: v('text-ghost'),
  muted: v('muted'), muted85: v('muted-85'), muted80: v('muted-80'), muted76: v('muted-76'),
  muted75: v('muted-75'), muted70: v('muted-70'), muted60: v('muted-60'), muted50: v('muted-50'),
  border35: v('border-35'), border30: v('border-30'), border20: v('border-20'), border16: v('border-16'),
  border: v('border'), border10: v('border-10'), border06: v('border-06'), border55: v('border-55'),
  shadow: v('shadow'),
  outline: v('outline'), outlineHover: v('outline-hover'), overlay10: v('overlay-10'), overlay08: v('overlay-08'),
  accent: v('accent'), accent40: v('accent-40'), accent30: v('accent-30'), accent18: v('accent-18'),
  accentTint: v('accent-tint'), accentTint12: v('accent-tint-12'), accent50: v('accent-50'), sky: v('sky'),
  primary: v('primary'), primaryHover: v('primary-hover'), primary25: v('primary-25'), onPrimary: v('on-primary'),
  blue: v('blue'), blue40: v('blue-40'), blueLight: v('blue-light'), blueStrong: v('blue-strong'),
  blueGoogle: v('blue-google'), indigo: v('indigo'),
  danger: v('danger'), danger95: v('danger-95'), danger18: v('danger-18'), danger16: v('danger-16'),
  danger45: v('danger-45'), danger08: v('danger-08'),
  dangerStrong: v('danger-strong'), dangerLight: v('danger-light'), dangerSoft: v('danger-soft'),
  warning: v('warning'), warning12: v('warning-12'), warning90: v('warning-90'), warningStrong: v('warning-strong'),
  orange: v('orange'), success: v('success'), successStrong: v('success-strong'), success90: v('success-90')
};
